
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { ProfileGrid } from "./components/ProfileGrid";
import { CallToAction } from "./components/CallToAction";
import { Footer } from "./components/Footer";
import { LoginPage } from "./components/LoginPage";
import { Loginverify } from "./components/Loginverify";
import { RegisterPage } from "./components/RegisterPage";
import BrowsePage from "./components/BrowsePage";
import { SearchPage } from "./components/SearchPage";
import { MatchesPage } from "./components/MatchesPage";
import { MessagesPage } from "./components/MessagesPage";
import { ProfileDashboard } from "./components/ProfileDashboard";
import SubscriptionPage from "./components/SubscriptionPage";
import { ProfileViewPage } from "./components/ProfileViewPage";
import { AdminLogin } from "./components/admin/AdminLogin";
import { AdminDashboard } from "./components/admin/AdminDashboard";
import InterestReceiveList from "./components/IntersetReceive";
import InterestSendList from "./components/InterestSend";
import Loader from './components/Loader'
import Profileviews from "./components/Profileviews";
import "./i18n";
import { Helmet } from "react-helmet";
import NotFoundPage from "./components/404page";
import Paymenthistory from "./components/Paymenthistory";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CancellationRefund from "./components/CancellationRefund";
import ShippingExchange from "./components/ShippingExchange";
import ContactUs from "./components/ContactUs";
import { EmailLoginPage } from "./components/EmailLoginPage";
import { JathakalayaSection } from "./components/JathakalayaSection";
import { MatrimonialBannerSection } from "./components/MatrimonialBannerSection";

function HomePage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Header />
      <HeroSection />
      <JathakalayaSection />
      <ProfileGrid />
      <MatrimonialBannerSection />
      <CallToAction />
      <Footer />
    </>
  );
}

export default function App() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }


  return (
    <Router>
      <Routes>
        {/* ✅ Public Pages */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<EmailLoginPage />} />
        <Route path="/mobile-login" element={<LoginPage />} />
        <Route path="/otp" element={<Loginverify />} />
        <Route path="/email-login" element={<EmailLoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* ✅ User Pages */}
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/matches" element={<MatchesPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/profile" element={<ProfileDashboard />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
        <Route path="/profile-views" element={<Profileviews />} />
        <Route path="/interest-receive" element={<InterestReceiveList />} />
        <Route path="/interest-send" element={<InterestSendList />} />
        <Route path="/view-profile/:id" element={<ProfileViewPage />} />
        <Route path="/payment" element={<Paymenthistory />} />
        <Route path="/t&c" element={<TermsAndConditions/>}/>
        <Route path="/privacy" element={<PrivacyPolicy/>}/>
        <Route path="/cancellation" element={<CancellationRefund/>}/>
        <Route path="/shipping" element={<ShippingExchange/>}/>
        <Route path="/contact" element={<ContactUs/>}/>

        {/* ✅ Admin Pages */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}
